(function(jQuery) {
// Polyfill for Symbol if needed
if (typeof Symbol === 'undefined') {
	window.Symbol = function Symbol(key) {
		return key;
	};
}

// Cache window and document objects
var $window = jQuery(window);
var $document = jQuery(document);

// Declare currentPosition and currentTransition globally for use in off-canvas functionality
var currentPosition = "";
var currentTransition = "";

// Document ready handler
$document.ready(function() {
	initJsGlobal();
	initNavigation();
	initGalleries();
	initReplaceFancybox();
	clickToExpand();

	// Initialize OffCanvasSwitcher only if the element exists
	if (jQuery('#off-canvas').length) {
		initOffCanvasSwitcher();
	}

	passFormTitleAsFormName();
	
	primaryLinkIconInjection();
	secondaryLinkIconInjection();
	dynamicFooterHeight();
	
	addActiveClassToMegaMenuItem();
	
	pulseButton();
	
	aboveFoldSlider();
	
	initHellobar();
	
	activeTiles();
});

jQuery(document).ready(function () {
	jQuery(".wp-block-search__input").each(function () {
		var searchInput = jQuery(this);
		var clearButton = jQuery("<span class='custom-search-clear'>&times;</span>");

		// Wrap input and append clear button
		searchInput.wrap("<div style='position: relative; display: inline-block; width: 100%;'></div>");
		searchInput.after(clearButton);

		// Show/hide clear button based on input value
		function toggleClearButton() {
			if (searchInput.val().length > 0) {
				clearButton.addClass("visible");
			} else {
				clearButton.removeClass("visible");
			}
		}

		// Click event to clear input
		clearButton.on("click", function () {
			searchInput.val("").focus();
			toggleClearButton();
		});

		// Input event to show/hide button
		searchInput.on("input", toggleClearButton);
		
		// Initialize visibility
		toggleClearButton();
	});
});

jQuery(document).ready(function () {
	if (window.location.pathname.includes("/contact/")) {
		jQuery("#content").addClass("contact-page");
	}
	if (window.location.pathname.includes("/thank-you/")) {
		jQuery("#content").addClass("thank-you-page");
	}
});

//Above Fold Swiper Script
//---------------------------------------------------------------
function aboveFoldSlider(){
var sliderContainer = jQuery('<div>', {
	class: 'swiper-container above-fold-slider'
  });

  var sliderWrapper = jQuery('<div>', {
	class: 'swiper-wrapper'
  });
  
  // Clone the existing figures and append them to the slid er wrapper
	jQuery('#logo-section .kt-inside-inner-col figure').each(function() {
	  var slide = jQuery('<div>', {
		class: 'swiper-slide' 
	  });
  
	  var clonedFigure = jQuery(this).clone();
	  slide.append(clonedFigure);
	  sliderWrapper.append(slide);
	});
  
	sliderContainer.append(sliderWrapper);
  
	// Append the slider container after the original container
	jQuery('#logo-section').append(sliderContainer);
	
	// Initialize Swiper
	 var swiper = new Swiper('.above-fold-slider', {
	   // slidesPerView: 'auto',
	   centeredSlides: true,
	   spaceBetween: 5,
	   initialSlide: 1,
	   loop: true,
	   navigation: {
		 // nextEl: '.swiper-button-next',
		 // prevEl: '.swiper-button-prev',
	   },
	   breakpoints:{
		   320:{
			   // slidesPerView: 1.3,
			   // spaceBetween: 20
			   slidesPerView: 2.6,
				spaceBetween: 50
		   },
		   480: {
			 slidesPerView: 2.6,
			 spaceBetween: 30
		   },
		   540: {
			   slidesPerView: 2.6,
			 spaceBetween: 30
		   }
		   
	   },
	   autoplay: {
		 delay: 3000, // Set the desired autoplay delay in milliseconds
		 disableOnInteraction: false, // Allow autoplay to continue after user interactions
	   },
	 });
}

//---------------------------------------------------------------


function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
}




function pulseButton(){
	jQuery('.is-style-link-with-play-icon-before >*').each(function() {
		jQuery(this).prepend('<div class="pulse-button"><svg xmlns="http://www.w3.org/2000/svg" width="13.947" height="16.409" viewBox="0 0 13.947 16.409"><path d="M8.2,0l8.2,13.947H0Z" transform="translate(13.947) rotate(90)" fill="#fff7e8"/></svg></span>');
	});
}


function addActiveClassToMegaMenuItem() {
	// Remove trailing slashes so "/about" and "/about/" are treated the same
	function normalizePath(path) {
		return path.replace(/\/+$/, '');
	}
	
	var currentPath = normalizePath(window.location.pathname);
	// console.log("Current Path:", currentPath);
	
	jQuery('.mega-menu-link-group p a').each(function() {
		var linkPath = normalizePath(new URL(this.href, window.location.origin).pathname);
		// console.log("Link Path:", linkPath, "for", this.href);
		if (linkPath === currentPath) {
			jQuery(this).addClass('active');
			// console.log("Active class added to:", this.href);
		}
	});
}


function activeTiles(){
	var currentPath = window.location.pathname.replace(/\/$/, ''); // Get current path and normalize by removing trailing slash
	console.log('Current page pathname:', currentPath);
	
	// Loop through <a> tags inside .tile-2 and .tile-3
	jQuery('.tile-2 a, .tile-3 a').each(function() {
		var anchorHref = jQuery(this).attr('href'); // Get href attribute of the <a> tag
		// console.log('Anchor HREF:', anchorHref);
	
		if (anchorHref) {
			var normalizedHref = anchorHref.replace(/\/$/, ''); // Normalize by removing trailing slash
			// console.log('Normalized HREF:', normalizedHref);
	
			// Compare current path with normalized href
			if (currentPath === normalizedHref) {
				jQuery(this).addClass('active'); // Add 'active' class if paths match
				// console.log('Match found! Active class added to:', normalizedHref);
			}
		} else {
			// console.log('No HREF found for this anchor.');
		}
	});
}


// Inject Arrow Icon into Primary Link W Arrow
function primaryLinkIconInjection() {
	// Select all instances of .is-style-primary-link-w-arrow
	jQuery('.is-style-primary-link-w-arrow a').each(function() {
		// Append an element with the class .primary-link-icon inside each instance
		jQuery(this).wrapInner('<span class="primary-link"></span>');
		jQuery(this).append('<span class="link-icon"></span>');
	});
}
function secondaryLinkIconInjection() {
	// Select all instances of .is-style-primary-link-w-arrow
	jQuery('.is-style-secondary-link-w-arrow a').each(function() {
		// Append an element with the class .primary-link-icon inside each instance
		jQuery(this).wrapInner('<span class="secondary-link"></span>');
		jQuery(this).append('<span class="link-icon"></span>');
	});
}

function dynamicFooterHeight() {
  const main = jQuery("#visit-office-wrap");
  const footer = jQuery("#bottom-hidden-footer");
  
  // Set initial visibility to hidden
  footer.css("visibility", "hidden");
  if (footer.length === 0 || main.length === 0) {
	console.error("Element(s) not found:", {
	  footerExists: footer.length > 0,
	  mainExists: main.length > 0,
	});
	return;
  }

  const updateDynamicValues = () => {
	const footerHeight = footer.outerHeight() || 0;
	main.css("margin-bottom", `${footerHeight}px`);
  };

  const handleScroll = () => {
	const scrollPosition = window.scrollY + window.innerHeight;
	const mainBottom = main.offset().top + main.outerHeight();

	if (scrollPosition >= mainBottom && main.outerHeight() > 0) {
	  footer.css("visibility", "visible");
	  footer.css("opacity", "1");
	} else {
	  footer.css("visibility", "hidden");
	  footer.css("opacity", "0");
	}
  };

  // Update values on load
  updateDynamicValues();

  // Listen to resize events
  jQuery(window).on("resize", () => {
	updateDynamicValues();
  });
  jQuery(window).on("orientationchange", () => {
	updateDynamicValues();
  });

  // Listen to scroll events
  jQuery(window).on("scroll", () => {
	handleScroll();
  });

  // Monitor footer for height changes
  const observer = new MutationObserver(() => {
	updateDynamicValues();
  });

  observer.observe(footer[0], {
	attributes: true,
	childList: true,
	subtree: true,
  });

  // Clean up observer when the page is unloaded
  jQuery(window).on("unload", () => {
	observer.disconnect();
  });
}










// Function to optimize form field names for GA4 form tracking
function passFormTitleAsFormName() {
	jQuery('.gform_wrapper form').each(function() {
		var $form = jQuery(this);
		var formTitle = $form.closest('.gform_heading').find('.gform_title').text();
		var formID = $form.attr('id');
		$form.attr('name', formTitle + ' - ' + formID);
	});
}

// Remove empty P tags created by WP and add responsive embeds to YouTube and Vimeo
function initJsGlobal() {
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		var $this = jQuery(this);
		var isWidescreen = $this.innerWidth() / $this.innerHeight() > 1.5;
		$this.wrap("<div class='" + (isWidescreen ? 'widescreen' : '') + " responsive-embed'/>");
		$this.attr('loading', 'lazy'); // Lazy load the iframes
	});

	jQuery('.lower-bar, .sticky-wrapper-navigation').removeClass('wait-js');
	//jQuery('<div class="svg-quote">...</div>').prependTo('blockquote');
}

// Optimize OffCanvasSwitcher event handling and DOM manipulation
function initOffCanvasSwitcher() {
	var $offCanvas = jQuery('#off-canvas');

	function setOffcanvasPosition(newSize) {
		var mobileOffcanvas = $offCanvas.data("mobile").split(" ");
		var tabletOffcanvas = $offCanvas.data("tablet").split(" ");

		if (newSize == 'xmedium' || newSize == 'medium') {
			switchPosition(tabletOffcanvas);
		} else if (newSize == 'smedium' || newSize == 'small' || newSize == 'xsmall') {
			switchPosition(mobileOffcanvas);
		}
	}

	function switchPosition(offcanvasConfig) {
		var [position, transition] = offcanvasConfig;
		$offCanvas
			.removeClass("position-" + currentPosition)
			.addClass("position-" + position)
			.attr("data-transition", transition)
			.removeClass("is-transition-" + currentTransition)
			.addClass("is-transition-" + transition);
		currentPosition = position;
		currentTransition = transition;
	}

	$window.on('load changed.zf.mediaquery', function(event, newSize) {
		setOffcanvasPosition(newSize);
	});

	// Toggle classes for off-canvas open/close
	$offCanvas.on('opened.zf.offCanvas', function() {
		jQuery("body").addClass('offCanvasOpen');
		jQuery(".hamburger").addClass("is-active");
	});

	$offCanvas.on('close.zf.offCanvas', function() {
		jQuery("body").removeClass('offCanvasOpen');
		jQuery(".hamburger").removeClass("is-active");
	});
}

// Simplify gallery click events
function initGalleries() {
	jQuery('.imgGalItem').click(function(event) {
		var $this = jQuery(this);
		var link = $this.data('link');
		var rel = $this.attr('rel');
		var height = $this.attr('height');
		var width = $this.attr('width');
		var counts = $this.data('groups');

		var newContent = '<a href="' + link + '" rel="galSlideCell' + rel + '" data-fancybox="group' + counts + '" data-caption="*Individual Results May Vary"><img src="' + link + '" height="' + height + '" width="' + width + '"></a>';
		var $mainGalImg = jQuery(".galSlideCell" + rel + " .main-gal-img");
		var containerHeight = $mainGalImg.height();

		jQuery(".photoGallery" + rel).removeClass("is-active");
		$this.addClass("is-active");

		$mainGalImg.stop().css({ 'opacity': '0', 'height': containerHeight + 'px' }).html(newContent).animate({
			opacity: 1
		}, 500);

		setTimeout(function() {
			$mainGalImg.css('height', 'auto');
		}, 500);

		event.preventDefault();
		return false;
	});
}

// Optimize fancybox attribute assignment
function initReplaceFancybox() {
	var fancyboxes = jQuery('.fancy-box a, .fancybox a, .is-style-button-has-play-video a, .is-style-play-video-link-w-icon a');
	fancyboxes.attr('data-fancybox', '');
}

// Sticky navigation initialization
function initNavigation() {
	var $stickyNav = jQuery('.sticky-wrapper-navigation');
	$stickyNav.on('sticky.zf.stuckto:top', function() {
		$stickyNav.addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function() {
		$stickyNav.removeClass('shrink');
	});
}

// Function to handle expand/collapse content
function clickToExpand() {
	jQuery('.is-style-click-to-expand').each(function() {
		var $this = jQuery(this);
		var ehmax = $this.data('eh-max');
		var $content = $this.wrapInner('<div class="expandrContent"></div>').find('.expandrContent');
		$this.append('<a class="expandBtn"><span class="showMe">Click To Expand</span><span class="hideMe">Click To Collapse</span> <i class="rotateMe none fa fa-angle-double-right" aria-hidden="true"></i></a>');
		$content.css('max-height', ehmax);
		$this.css('max-height', ehmax);

		$this.find('.expandBtn').click(function() {
			var $btn = jQuery(this);
			$btn.find('.rotateMe').toggleClass('none down');
			$btn.find('span').toggleClass('showMe hideMe');
			$content.toggleClass('expanded');
			$btn.toggleClass('expanded');
		});
	});
	jQuery('.is-style-team-click-to-expand').each(function() {
		var $this = jQuery(this);
		var ehmax = $this.data('eh-max');
		var $content = $this.wrapInner('<div class="expandrContent"></div>').find('.expandrContent');
		$this.prepend('<a class="expandBtn"><span class="showMe">Read More</span><span class="hideMe">Collapse Bio</span> <i class="rotateMe none fa fa-angle-double-right" aria-hidden="true"></i></a>');
		$content.css('max-height', ehmax);
		$this.css('max-height', ehmax);

		$this.find('.expandBtn').click(function() {
			var $btn = jQuery(this);
			$btn.find('.rotateMe').toggleClass('none down');
			$btn.find('span').toggleClass('showMe hideMe');
			$content.toggleClass('expanded');
			$btn.toggleClass('expanded');
		});
	});
}


	var navigator;
	var DocumentTouch;


	//	Animations v1.1, Joe Mottershaw (hellojd)
	//	https://github.com/hellojd/animations / https://github.com/Sananes/animations

	//	==================================================

	//	Visible, Sam Sehnert, samatdf, TeamDF
	//	https://github.com/teamdf/jquery-visible/
	//	==================================================

	(function($) {

		$.fn.visible = function(partial, hidden, direction) {
			var $t = jQuery(this).eq(0),
				t = $t.get(0),
				$w = jQuery(window),
				viewTop = $w.scrollTop(),
				viewBottom = viewTop + $w.height(),
				viewLeft = $w.scrollLeft(),
				viewRight = viewLeft + $w.width(),
				_top = $t.offset().top,
				_bottom = _top + $t.height(),
				_left = $t.offset().left,
				_right = _left + $t.width(),
				compareTop = partial === true ? _bottom : _top,
				compareBottom = partial === true ? _top : _bottom,
				compareLeft = partial === true ? _right : _left,
				compareRight = partial === true ? _left : _right,
				clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;
			direction = (direction) ? direction : 'both';

			if (direction === 'both')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
			else if (direction === 'vertical')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
			else if (direction === 'horizontal')
				return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
		};


		$.fn.fireAnimations = function(options) {
			function animate() {
				if (jQuery(window).width() >= 0) {
					jQuery('.animate__animated').each(function(i, elem) {
						elem = jQuery(elem);
						//var	type = jQuery(this).attr('data-anim-type'),
						//delay = jQuery(this).attr('data-anim-delay');

						if (elem.visible(true)) {
							setTimeout(function() {
								elem.addClass('trigger');
							}, 100);
						}
					});
				} else {
					jQuery('.animate__animated').each(function(i, elem) {
						elem = jQuery(elem);
						var type = jQuery(this).attr('data-anim-type'),
							delay = jQuery(this).attr('data-anim-delay');

						setTimeout(function() {
							elem.addClass(type);
						}, delay);
					});
				}
			}

			jQuery(document).ready(function() {
				jQuery('html').removeClass('no-js').addClass('js');

				animate();
			});

			jQuery(window).scroll(function() {
				animate();

				if (jQuery(window).scrollTop() + jQuery(window).height() == jQuery(document).height()) {
					animate();
				}
			});
		};

		jQuery('.animate').fireAnimations();

	})(jQuery);

	var triggerClasses = 'flash strobe shake bounce tada wave spin pullback wobble pulse pulsate heartbeat panic explode';

	var classesArray = [];
	classesArray = triggerClasses.split(' ');

	var classAmount = classesArray.length;
	var type;

	function randomClass() {
		var random = Math.ceil(Math.random() * classAmount);

		type = classesArray[random];

		return type;
	}

	function triggerOnce(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

	function triggerInfinite(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger infinite').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

	jQuery(window).resize(function() {
		jQuery('.animate').fireAnimations();
	});


	function initBrowserExposure() {



		var uaMatch = '',
			prefix = '';

		if (navigator.userAgent.match(/Windows/)) {
			jQuery('html').addClass('windows');
		} else if (navigator.userAgent.match(/Mac OS X/)) {
			jQuery('html').addClass('macOs');
		} else if (navigator.userAgent.match(/X11/)) {
			jQuery('html').addClass('x11');
		}

		var supports = (function() {
			var d = document.documentElement,
				c = "ontouchstart" in window || navigator.msMaxTouchPoints;
			if (c) {
				d.className += " touch";
				return {
					touch: true
				}
			} else {
				d.className += " no-touch";
				return {
					touch: false
				}
			}
		})();

		// browser
		if (navigator.userAgent.match(/Chrome/)) {
			uaMatch = ' Chrome/';
			prefix = 'chrome';
		} else if (navigator.userAgent.match(/Safari/)) {
			uaMatch = ' Version/';
			prefix = 'safari';
		} else if (navigator.userAgent.match(/Firefox/)) {
			uaMatch = ' Firefox/';
			prefix = 'firefox';
		} else if (navigator.userAgent.match(/MSIE/)) {
			uaMatch = ' MSIE ';
			prefix = 'x-msie';
		}
		// add result preifx as browser class
		if (prefix) {
			jQuery('html').addClass(prefix);
		}

	}

	// Get IE or Edge browser version
	var version = detectIE();

	if (version === false) {
		jQuery('html').addClass('not-ie-edge');
	} else if (version >= 12) {
		jQuery('html').addClass('edge edge-' + version);
	} else {
		jQuery('html').addClass('ie ie-' + version);
	}

	// add details to debug result
	//document.getElementById('details').innerHTML = window.navigator.userAgent;

	/**
	 * detect IE
	 * returns version of IE or false, if browser is not Internet Explorer
	 */

	function detectIE() {
		var ua = window.navigator.userAgent;

		// Test values; Uncomment to check result …

		// IE 10
		// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

		// IE 11
		// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

		// Edge 12 (Spartan)
		// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

		// Edge 13
		// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		var edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		// other browser
		return false;
	}
})(jQuery);